// extracted by mini-css-extract-plugin
export default {"content":"content-module--content--j7rTj"};